import { Helmet } from 'react-helmet'
export default function Head() {
  return (
    <Helmet>
      <html lang="en" />
      <title>Yeeha Games</title>
      <meta name="description" content="Yeeha Games Gamefi" />
      <meta name="theme-color" content="#000000" />
    </Helmet>
  )
}
